import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSourcegraphComponent } from './simple-icons-sourcegraph.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSourcegraphComponent ],
    exports:      [ SimpleIconsSourcegraphComponent ],
    bootstrap:    []
})
export class SimpleIconsSourcegraphModule {}
